// Components
import { StyledActionsWrap } from './PickupLocationsTableActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { StyledActionButton } from '@/components';

// Helpers
import { COLORS } from '@/theme';
import { IPickup } from '@/models/regions.model';

type TPickupLocationsTableActionsProps = {
  onDelete: (pickup: IPickup) => void;
  onUpdate: (pickup: IPickup) => void;
  pickup: IPickup;
};

const PickupLocationsTableActions = ({ onDelete, onUpdate, pickup }: TPickupLocationsTableActionsProps) => {
  const handleDelete = () => onDelete(pickup);

  const handleUpdate = () => onUpdate(pickup);

  return (
    <StyledActionsWrap>
      <StyledActionButton $color={COLORS.PALE_YELLOW} onClick={handleUpdate}>
        <EditIcon />
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default PickupLocationsTableActions;
